import React from "react";
import CommonTable from "../CommonTable";
import dayjs from "dayjs";
import { convertUtcToIst } from "../../../../helpers/utility";
const Diet = ({ data }) => {
  // console.log(data);
  const columns = [
    {
      title: "Time Done",
      dataIndex: "action_time",
      key: "action_time",
      render: (value) => convertUtcToIst(value, true, true),
    },
    {
      title: "Item",
      dataIndex: "item",
      key: "item",
      render: (item) => `${item?.name} x ${item?.quantity}`,
    },
  ];
  return (
    <div>
      <CommonTable data={data} columns={columns} />
    </div>
  );
};

export default Diet;
